import { RateSchema_ } from "@redotech/redo-fulfillment-carrier-common/shipment";
import { WeightSchema } from "@redotech/redo-fulfillment-outbound-labels-common/util";

import { AddressSchema } from "@redotech/account-common/address-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum PurchaseLabelType {
  Replace = "replace",
  New = "new",
}

export enum PurchaseLabelError {
  CARRIER_ERROR = "carrier_error",
  INTERNAL_ERROR = "internal_error",
  LABEL_PRICE_TOO_HIGH = "label_price_too_high",
  UPS_PHONE_NUMBER_TOO_SHORT = "ups_phone_number_too_short",
  UPS_MISSING_SHIP_FROM_NAME = "ups_missing_ship_from_name",
  USPS_PHONE_NUMBER_INVALID = "usps_phone_number_invalid",
  MISSING_CUSTOMER_NAME = "missing_customer_name",
}

export const purchaseLabel = {
  name: "purchaseLabel" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    rate: RateSchema_,
    weight: WeightSchema.optional(),
    shipmentId: z.string().optional(),
    shipmentGroupId: z.string().optional(),
    toAddress: AddressSchema,
    fromAddress: AddressSchema,
    labelType: createEnum(PurchaseLabelType),
    originalLabelCost: z.number(),
    /**
     * Set when this label is replacing a dropoff being edited. The label is then
     * billed as a difference over that dropoff's prior flat-rate fee instead of
     * as a new label, mirroring how editing a dropoff is billed.
     */
    replacedDropoffGroupId: z.string().optional(),
    isAdditionalShipment: z.boolean().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    shipmentId: z.string().optional(),
    labelUrl: z.string().optional(),
    qrCodeUrl: z.string().optional(),
    trackingNumber: z.string().optional(),
    error: createEnum(PurchaseLabelError).optional(),
    charge: z.number().optional(),
  }),
};
